/**
 * User: Rob Richard
 * Date: 5/16/14
 * Time: 12:42 PM
 */

'use strict';
var _ = require('underscore');

var anchorFunctions = [
    'getAnchorIdByType',
    'getAnchorByType',
    'hasAnchor',
    'setAnchorId'
];

/**
 * Proxy anchor collection functions onto a model with an anchor association.
 *
 * Add this mixin to any model that has an Anchor collection on it's anchor
 * property.
 *
 * Creates an object of the above functions. Calling them will call that function
 * on the 'anchors' collection of this.
 */
module.exports = _.reduce(anchorFunctions, function (memo, anchorFunction) {
    memo[anchorFunction] = function () {
        var anchors = this.get('anchors');
        return anchors[anchorFunction].apply(anchors, arguments);
    };
    return memo;
}, {});


//////////////////
// WEBPACK FOOTER
// ./~/bunsen/models/mixins/anchorMixin.js
// module id = 2642
// module chunks = 62